import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
   selector: 'app-step-progress',
   templateUrl: './step-progress.component.html',
   styleUrls: ['./step-progress.component.css']
})
export class StepProgressComponent implements OnInit {

   isLinear = true;
   firstFormGroup: FormGroup;
   secondFormGroup: FormGroup;

   constructor(private _formBuilder: FormBuilder) {
   }

   ngOnInit() {
      this.firstFormGroup = this._formBuilder.group({
         // firstCtrl: ['', Validators.required]
      });
      this.secondFormGroup = this._formBuilder.group({
         // secondCtrl: ['', Validators.required]
      });
   }

}
